import React from 'react';
import { cn } from '@utils/classNames';

interface SidebarTooltipProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

/** Tooltip shown to the right of sidebar rail when collapsed (desktop only). */
export const SidebarTooltip: React.FC<SidebarTooltipProps> = ({
  label,
  children,
  className,
}) => (
  <div className={cn('group relative flex justify-center', className)}>
    {children}
    <span
      role="tooltip"
      className={cn(
        'pointer-events-none absolute left-full top-1/2 z-[200] ml-2 -translate-y-1/2',
        'whitespace-nowrap rounded-md bg-dark-secondary px-2.5 py-1.5',
        'text-xs font-codec font-bold text-white shadow-lg border border-white/10',
        'opacity-0 scale-95 transition-all duration-150',
        'group-hover:opacity-100 group-hover:scale-100 group-focus-within:opacity-100 group-focus-within:scale-100'
      )}
    >
      {label}
    </span>
  </div>
);
